module.exports = __webpack_public_path__ + "img/env_icon1.1d0c3976.png";